import { render, staticRenderFns } from "./PurchasingPaymentGroupForm.vue?vue&type=template&id=846d1c8c"
import script from "./PurchasingPaymentGroupForm.vue?vue&type=script&lang=js"
export * from "./PurchasingPaymentGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports